import { useState, useEffect, useCallback } from "react";

// Define types for each location result returned by Nominatim
export interface NominatimResult {
  place_id: number;
  display_name: string;
  name: string;
  lat: string;
  lon: string;
}

interface UseNominatimGeocodingResult {
  results: NominatimResult[];
  loading: boolean;
}

function useNominatimGeocoding(
  query: string,
  language: string = "en",
): UseNominatimGeocodingResult {
  const [results, setResults] = useState<NominatimResult[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const countryCodes = "AE";
  const viewbox = "51.5795186705,22.4969475367,56.3968473651,26.055464179";

  // Fetch locations from Nominatim API
  const fetchLocations = useCallback(async () => {
    if (!query) {
      setResults([]);
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${query}&countrycodes=${countryCodes}&addressdetails=1&limit=10&bounded=1&viewbox=${viewbox}&accept-language=${language}`,
      );
      const data: NominatimResult[] = await response.json();
      setResults(data);
    } catch (error) {
      console.error("Error fetching data from Nominatim:", error);
      setResults([]);
    } finally {
      setLoading(false);
    }
  }, [query, language]);

  // UseEffect with inline debounced fetch
  useEffect(() => {
    fetchLocations();
  }, [fetchLocations]);

  return { results, loading };
}

export default useNominatimGeocoding;
